var _rect, _ellipse, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 12,
    fill: "url(#paint0_linear_38_503)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27,
    cy: 26.9513,
    rx: 20,
    ry: 15.9513,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 42.9026C13 41.3075 13.1667 38.9148 13 37.9178L18.5 38.9148C16.9 42.9026 12.8333 43.2349 11 42.9026Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.065 16.935C29.5814 16.4186 30.4235 16.4152 30.8942 16.9736C31.9229 18.1939 32.7594 19.5674 33.3722 21.0468C34.154 22.9342 34.5563 24.9571 34.5563 27C34.5563 29.0429 34.154 31.0658 33.3722 32.9532C32.7594 34.4326 31.9229 35.8061 30.8942 37.0264C30.4235 37.5848 29.5814 37.5814 29.065 37.065C28.5486 36.5486 28.5547 35.7153 29.0155 35.1488C29.804 34.1798 30.4491 33.0996 30.9289 31.9411C31.5778 30.3746 31.9118 28.6956 31.9118 27C31.9118 25.3044 31.5778 23.6254 30.9289 22.0589C30.4491 20.9004 29.804 19.8202 29.0155 18.8512C28.5547 18.2847 28.5486 17.4514 29.065 16.935Z",
    fill: "#2644C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.12 19.88C24.606 19.394 25.4002 19.3902 25.8299 19.9266C26.4962 20.7584 27.043 21.6819 27.4525 22.6704C28.0211 24.0431 28.3137 25.5143 28.3137 27C28.3137 28.4857 28.0211 29.9569 27.4525 31.3296C27.043 32.3181 26.4962 33.2416 25.8299 34.0734C25.4002 34.6098 24.606 34.606 24.12 34.12C23.634 33.634 23.6423 32.8505 24.0551 32.301C24.4994 31.7096 24.8686 31.0634 25.153 30.3771C25.5964 29.3064 25.8247 28.1589 25.8247 27C25.8247 25.8411 25.5964 24.6936 25.153 23.6229C24.8686 22.9366 24.4994 22.2904 24.0551 21.699C23.6423 21.1495 23.634 20.366 24.12 19.88Z",
    fill: "#2644C7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 22.875C19.6082 22.3918 20.4024 22.3869 20.7942 22.9469C21.0879 23.3668 21.3358 23.8184 21.5328 24.294C21.8882 25.1519 22.0711 26.0714 22.0711 27C22.0711 27.9286 21.8882 28.8481 21.5328 29.706C21.3358 30.1816 21.0879 30.6332 20.7942 31.0531C20.4024 31.6131 19.6082 31.6082 19.125 31.125C18.6418 30.6418 18.6601 29.8628 18.9974 29.2684C19.0906 29.1042 19.1738 28.9341 19.2463 28.7589C19.4773 28.2013 19.5962 27.6036 19.5962 27C19.5962 26.3964 19.4773 25.7987 19.2463 25.2411C19.1738 25.0659 19.0906 24.8958 18.9974 24.7316C18.6601 24.1372 18.6418 23.3582 19.125 22.875Z",
    fill: "#2644C7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_38_503",
    x1: 27,
    y1: 0,
    x2: 27,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4363EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2543C6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f05cd73241d841a2f6b205553fac60fb.svg";
export { ForwardRef as ReactComponent };